import { render, staticRenderFns } from "./TabOxygenConcentrator.vue?vue&type=template&id=3fb54803&scoped=true"
import script from "./TabOxygenConcentrator.vue?vue&type=script&lang=js"
export * from "./TabOxygenConcentrator.vue?vue&type=script&lang=js"
import style0 from "./TabOxygenConcentrator.vue?vue&type=style&index=0&id=3fb54803&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb54803",
  null
  
)

export default component.exports